module.exports = __webpack_public_path__ + "ec3bdd61c341874cd5b96512cc176ac2.jpg";